export class TableRecord {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "rowCount",
            "baseName": "rowCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<ColumnMetadata>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableRecord.attributeTypeMap;
    }
    constructor() {
    }
}
